<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="firstName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="lastName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="email">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'mobilePhone'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column [allowDescendingSorting]="false" field="firstName"></wbo-main-search-column>
        <wbo-column [allowDescendingSorting]="false" field="lastName"></wbo-column>
        <wbo-column [allowDescendingSorting]="false" field="email"></wbo-column>
        <wbo-column [sortable]="false" field="mobilePhone"></wbo-column>
        <wbo-date-column [sortable]="false" field="dob"></wbo-date-column>
        <wbo-actions-search-column>
            <wbo-delete-search-action [availableCallback]="canDelete"></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
